import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { LargePageSplitCandidateDetectorProps as DetectorProps } from './LargePageSplitCandidateDetector.tsx';

export type LargePageSplitCandidateDetectorProps = DetectorProps;

export const LazyLargePageSplitCandidateDetector: LoadableType<DetectorProps> = LoadableLazy({
	name: 'LargePageSplitCandidateDetector',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LargePageSplitCandidateDetector" */ './LargePageSplitCandidateDetector.tsx'
			)
		).LargePageSplitCandidateDetector,
});
